export const routes = {
  $root: '/',
  tickets: '/tickets',
  ticket: '/tickets/:ticketId',
  knowledgeBase: '/knowledge-base',
  knowledgeBaseCategory: '/knowledge-base/:category',
  knowledgeBaseTopic: '/knowledge-base/:category/:topic',
  community: '/community',
  communityTopics: '/community/topics',
  communityCategory: '/community/:category',
  communityQuestion: '/community/:category/:uuid/:slug',
  search: '/search',
  surveyFeedback: '/thank-you-for-your-feedback',
  demoSurvey: '/demo-feedback',
};
